import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';

/**
 * Component for showing login form.
 *
 * @extends React.Component
 */
class Menu extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    }
  }

  /**
   * Handle when user clicks expand icon.
   */
  handleClickExpand = () => {
    this.setState({expanded: !this.state.expanded});
  }

  /** @inheritdoc */
  render() {
    var menuClasses = 'navbar-collapse';
    if (!this.state.expanded) {
      menuClasses += ' collapse';
    }
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation" onClick={this.handleClickExpand}>
          <span className="navbar-toggler-icon" />
        </button>
        <div className={menuClasses} id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <Link to='/conversations' className="nav-link">Samtaler <span className="sr-only">(current)</span></Link>
            </li>
            <li className="nav-item">
              <Link to='/help' className="nav-link">Hjælp</Link>
            </li>
            <li className="nav-item">
              <Link to='/settings' className="nav-link">Indstillinger</Link>
            </li>
            <li className="nav-item">
              <Link to='/logout' className="nav-link text-danger">Log ud</Link>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default withRouter(withUser(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/index.js